import React from "react";
import { exportExcel } from "../utils/exportExcel";

const ExportExcelButton = ({ data, columns, fileName = "Export", label = "Export",  className = "btn btn-sm btn-primary" }) => (
  <button
    type="button"
    className={className}
    onClick={() => exportExcel(data, fileName, columns)}
  >
   {label}
  </button>
);

export default ExportExcelButton;
